
  import { css } from 'lit';
  export const styles = css`:host{--body-color: var(--ig-expansion-panel-body-color, var(--ig-gray-700));--disabled-text-color: var(--ig-expansion-panel-disabled-text-color, var(--ig-gray-400));--disabled-description-color: var(--ig-expansion-panel-disabled-description-color, var(--ig-gray-400));--ig-theme: fluent;--ig-theme-variant: light}`;
  